import styled, { css } from 'styled-components/macro';
import { IRequestStatus } from '../../types';
import { statusColorsMap } from './colors';

export const StatusContainer = styled.div<{ status: IRequestStatus }>`
  box-sizing: border-box;
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 12px;
  border-radius: 6px;
  gap: 8px;

  ${({ theme, status }) => {
    return css`
      background-color: ${statusColorsMap(theme.colors)[status].square};
    `;
  }}
`;

export const StatusCircle = styled.div<{ status: IRequestStatus }>`
  box-sizing: border-box;
  width: 8px;
  height: 8px;

  ${({ theme, status }) => css`
    border-radius: ${theme.radiuses.full};
    background-color: ${statusColorsMap(theme.colors)[status].dot};
  `}
`;
